(function($, duo, undefined) {

  "use strict";

  /**
  * Helper functions
  * @class Utils
  */
  class Utils {

    /**
    * Creates an instance of Utils
    */
    constructor() {
    } /* constructor */

    /**
    * Cross-browser helper for the transitionend-event
    * @readonly
    * @static
    */
    static get transitionEvent() {
      var t;
      var el = document.createElement('fakeelement');
      var transitions = {
          'transition': 'transitionend',
          'OTransition': 'oTransitionEnd',
          'MozTransition': 'transitionend',
          'WebkitTransition': 'webkitTransitionEnd'
      };
      for(t in transitions) {
        if(el.style[t] !== undefined) {
          return transitions[t];
        }
      }
    } /* transitionEvent */

    /**
    * Generate a unique ID
    * -> returns a value that can be used as a unique ID
    * @static
    */
    static get uniqueId() {
      return Math.random().toString(36).substr(2, 16);
    } /* uniqueId */

    /**
    * Check if the user has an OS "reduced motion" setting activated
    * -> use this function to determine whether or not an
    *    animation should be used
    * @static
    */
    static prefersReducedMotion() {
      if ('matchMedia' in window && window.matchMedia('(prefers-reduced-motion)').matches) {
        return true;
      }

      return false;
    } /* prefersReducedMotion */
  } /* Utils */

  duo.Utils = Utils;

})(jQuery, window.duo = window.duo || {});
